export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img1-63748e6389c5f4304309de79ea6ef61f.png";